import React from 'react'
// hocs
import { withDropzone } from 'hocs/index'
// hooks
import { useModalData, usePermissions } from 'hooks/index'
// components
import NodeInfo from '../NodeInfo'
import NodeMenu from '../NodeMenu'
import { HoverablePopover } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
// context
import { ReviewDrawerContext } from 'context/ReviewDrawerContext'
// views
import {
  ActionsIcon,
  CollapseIcon,
  Content as Wrapper,
  MeasuresIcon,
  NodeTitleWrapper
} from 'themes/views/objectivesList'
import { Content, ContentInnerWrapper, IconContainer, NodeTitle, Path } from './views'
// utils
import get from 'lodash/get'

const NodeContent = ({
  node,
  tree,
  isKPI,
  isRoot,
  isAction,
  nodeTitle,
  background,
  isObjective,
  hasChildren,
  handleKPIAdd,
  handleActionAdd,
  handleObjectiveAdd,
  handleCollapseClick
}) => {
  const isReview = React.useContext(ReviewDrawerContext)

  const {
    kpiAddKPI,
    actionAddKPI,
    kpiAddAction,
    kpiLinkObjects,
    kpiAddObjective,
    actionAddAction,
    objectiveAddKPI,
    planLinkObjects,
    actionLinkObjects,
    actionAddObjective,
    objectiveAddAction,
    objectiveLinkObjects,
    objectiveAddObjective,
    planAddItemsFromParentPlan
  } = usePermissions({ entity: node.entity, isAction, isKPI, isObjective })

  const {
    modalData: { id: activeActionId }
  } = useModalData({ modalType: Modals.ACTION_MINIMIZED_MODAL })

  const {
    modalData: { id: activeKPIid }
  } = useModalData({ modalType: Modals.KPI_MINIMIZED_MODAL })

  const {
    modalData: { id: activeObjectiveId }
  } = useModalData({ modalType: Modals.OBJECTIVE_MINIMIZED_MODAL })

  const isActive =
    activeKPIid === node.entity.id || activeActionId === node.entity.id || activeObjectiveId === node.entity.id

  const isNodeReferenced = node.referenced

  const canLink =
    (isAction && actionLinkObjects) ||
    (isKPI && kpiLinkObjects) ||
    (isObjective && objectiveLinkObjects) ||
    planLinkObjects

  const shouldShowAddActionButton =
    (isAction && actionAddAction) || (isKPI && kpiAddAction) || (isObjective && objectiveAddAction)

  const shouldShowAddObjectiveButton =
    (isAction && actionAddObjective) || (isKPI && kpiAddObjective) || (isObjective && objectiveAddObjective)

  const shouldShowAddKPIButton = (isAction && actionAddKPI) || (isKPI && kpiAddKPI) || (isObjective && objectiveAddKPI)

  const shouldShowMenu =
    !node.plan.locked &&
    !isReview &&
    (shouldShowAddActionButton ||
      shouldShowAddObjectiveButton ||
      shouldShowAddKPIButton ||
      (node.referenced && planAddItemsFromParentPlan))

  const nextLevelDescription = get(node, 'nextLevel.description')

  const titleWrapper = (
    <NodeTitleWrapper
      $isActive={isActive}
      $isReview={isReview}
      $isNodeReferenced={isNodeReferenced}
      $isObjective={isObjective && !isNodeReferenced}>
      {nodeTitle}
    </NodeTitleWrapper>
  )

  return (
    <Wrapper>
      {(isAction || isKPI) && (
        <IconContainer>
          {isAction ? <ActionsIcon /> : <MeasuresIcon />}
          <CollapseIcon
            $isKPI={isKPI}
            color={'inherit'}
            $isAction={isAction}
            $hidden={!hasChildren}
            $isExpanded={node.expanded}
            onClick={handleCollapseClick}
          />
        </IconContainer>
      )}

      <Content>
        <ContentInnerWrapper $isNodeReferenced={isNodeReferenced}>
          {shouldShowMenu ? (
            <NodeMenu
              node={node}
              tree={tree}
              canLink={canLink}
              isActive={isActive}
              nodeTitle={nodeTitle}
              handleKPIAdd={handleKPIAdd}
              handleActionAdd={handleActionAdd}
              handleObjectiveAdd={handleObjectiveAdd}
              nextLevelDescription={nextLevelDescription}
              isObjective={isObjective && !isNodeReferenced}
              shouldShowAddKPIButton={shouldShowAddKPIButton}
              shouldShowRemoveButton={planAddItemsFromParentPlan}
              shouldShowAddActionButton={shouldShowAddActionButton}
              shouldShowAddObjectiveButton={shouldShowAddObjectiveButton}
            />
          ) : isReview ? (
            <HoverablePopover trigger={titleWrapper}>
              <NodeTitle>{nodeTitle}</NodeTitle>
            </HoverablePopover>
          ) : (
            titleWrapper
          )}

          {isNodeReferenced && <Path>{node.path}</Path>}
        </ContentInnerWrapper>

        <NodeInfo
          node={node}
          tree={tree}
          isKPI={isKPI}
          isRoot={isRoot}
          isAction={isAction}
          background={background}
          isObjective={isObjective}
          handleKPIAdd={handleKPIAdd}
          handleActionAdd={handleActionAdd}
          handleObjectiveAdd={handleObjectiveAdd}
          nextLevelDescription={nextLevelDescription}
          shouldShowAddKPIButton={shouldShowAddKPIButton}
          shouldShowAddActionButton={shouldShowAddActionButton}
          shouldShowAddObjectiveButton={shouldShowAddObjectiveButton}
        />
      </Content>
    </Wrapper>
  )
}

export default withDropzone(NodeContent as any)
